webpackJsonp([1],{

/***/ 1000:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "unit-content"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    class: {
      "concentration-line": _vm.unit.type === "concentration"
    }
  }), _vm._v(" "), (_vm.unit.type === "concentration") ? _c('i', {
    staticClass: "fas fa-circle concentration-icon"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "unit-name"
  }, [_c('div', {
    staticClass: "unit-name-wrap"
  }, [_c('div', {
    staticClass: "unit-type"
  }, [_vm._v(_vm._s(_vm.type))]), _vm._v(" "), _vm._v("\n          " + _vm._s(_vm.label) + "\n        ")])]), _vm._v(" "), (_vm.active) ? [_c('div', {
    staticClass: "unit-period-select"
  }, [(_vm.planPeriod) ? _c('multiselect', {
    attrs: {
      "options": _vm.unit.planPeriods,
      "track-by": "id",
      "label": "name",
      "selected-label": "",
      "deselect-label": "",
      "select-label": "",
      "placeholder": "Select Period"
    },
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  }) : _c('span', [_vm._v(" ")])], 1)] : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1001:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "unit-content"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    class: {
      "concentration-line": _vm.unit.type === "concentration"
    }
  }), _vm._v(" "), (_vm.unit.type === "concentration") ? _c('i', {
    staticClass: "concentration-icon fas fa-circle"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "unit-name",
    style: (_vm.nameStyle),
    on: {
      "click": _vm.goToPlans
    }
  }, [_c('div', {
    staticClass: "unit-name-wrap"
  }, [_c('div', {
    staticClass: "unit-type"
  }, [_vm._v(_vm._s(_vm.type))]), _vm._v("\n          " + _vm._s(_vm.label) + "\n        ")])]), _vm._v(" "), (_vm.active) ? [_c('div', {
    staticClass: "unit-level"
  }, [(_vm.level) ? _c('span', [_vm._v(_vm._s(_vm.level))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "unit-availability"
  }, [(_vm.onlineAvailability) ? _c('span', [_vm._v(_vm._s(_vm.onlineAvailability))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "unit-plans"
  }, [(_vm.planPeriod) ? _c('span', [_vm._v(_vm._s(_vm.planCount) + " " + _vm._s(_vm.planString))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "unit-credits"
  }, [(_vm.planPeriod) ? _c('span', [_vm._v(_vm._s(_vm.planPeriod.major_credits) + " Credits")]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: "unit-info",
        params: _vm.unitParams
      }
    }
  }, [(_vm.unit.hasInfo || _vm.unit.cip_code) ? _c('button', {
    staticClass: "hollow"
  }, [_vm._v("Info")]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: "unit-plans",
        params: _vm.unitParams
      }
    }
  }, [(_vm.planPeriod) ? _c('button', {
    staticClass: "hollow"
  }, [_vm._v(_vm._s(_vm.planString))]) : _vm._e()])] : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1002:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 1003:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wildcard-requirement req"
  }, [_c('div', {
    staticClass: "reqinfo"
  }, [_c('div', {
    staticClass: "wildcard-name"
  }, [_vm._v(_vm._s(_vm.req.name))]), _vm._v(" "), _c('div', {
    staticClass: "req-item"
  }, [_vm._v("Credit Hours:\n      "), (_vm.req.minimum_credits === _vm.req.maximum_credits) ? [_vm._v("\n        " + _vm._s(_vm.req.minimum_credits) + "\n      ")] : [_vm._v("\n        " + _vm._s(_vm.req.minimum_credits) + " - " + _vm._s(_vm.req.maximum_credits) + "\n      ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 1004:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1005:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unitPeriod) ? _c('span', {
    attrs: {
      "id": "plans"
    }
  }, [_c('div', {
    attrs: {
      "id": "plan-tabs"
    }
  }, [(_vm.plans.length > 1) ? _c('ul', _vm._l((_vm.plans), function(plan, index) {
    return _c('li', {
      key: plan.id,
      staticClass: "ds-main ds-color ds-border-color plan-tab",
      class: {
        inactive: _vm.activePlan != plan
      },
      on: {
        "click": function($event) {
          _vm.activePlanIndex = index
        }
      }
    }, [_c('div', {
      staticClass: "plan-tab-name"
    }, [_vm._v(_vm._s(plan.plan.name))])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "plan-types"
  }, _vm._l((_vm.planTypes), function(type) {
    return _c('div', {
      key: type[0],
      staticClass: "plan-type ds-main ds-color",
      class: {
        selected: _vm.selectedPlanType === type, "ds-background": _vm.selectedPlanType === type
      },
      on: {
        "click": function($event) {
          _vm.selectedPlanType = type
        }
      }
    }, [_c('i', {
      staticClass: "fas",
      class: type[1]
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(type[0]))])])
  }), 0), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "up-down",
      "mode": "out-in"
    }
  }, _vm._l((_vm.plans), function(plan) {
    return (_vm.activePlan === plan) ? _c(_vm.selectedPlanType[0], {
      key: plan.id,
      tag: "component",
      attrs: {
        "termIdentifier": _vm.termIdentifier,
        "terms": _vm.formatTerms(plan.plan_terms)
      }
    }) : _vm._e()
  }), 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1006:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "degree-requirement req"
  }, [_c('div', {
    staticClass: "reqinfo"
  }, [_c('div', {
    staticClass: "requirement-name",
    on: {
      "click": function($event) {
        _vm.showSubreqs = !_vm.showSubreqs
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.req.name) + "\n      "), _c('i', {
    staticClass: "toggle-nested fa fa-caret-right",
    class: {
      'fa-rotate-90': _vm.showSubreqs
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "req-item"
  }, [(_vm.req.advanced) ? [_c('div', {
    staticClass: "req-satisfy variable blue"
  }, [_vm._v("Satisfy " + _vm._s(_vm.req.required) + " of " + _vm._s(_vm.subrequirements))]), _c('div', {
    staticClass: "req-satisfy credits blue"
  }, [_vm._v(_vm._s(_vm.req.minimum_credits) + " - " + _vm._s(_vm.req.maximum_credits) + " CR")])] : [_c('div', {
    staticClass: "req-satisfy variable"
  }, [_vm._v(_vm._s(_vm.req.minimum_credits) + " CR")]), _c('div', {
    staticClass: "req-satisfy credits"
  }, [_vm._v("Satisfy " + _vm._s(_vm.req.required) + " of " + _vm._s(_vm.subrequirements))])]], 2), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSubreqs),
      expression: "showSubreqs"
    }],
    staticClass: "subrequirements"
  }, _vm._l((_vm.req.subrequirements), function(req) {
    return _c('requirement', {
      key: req.id,
      ref: "requirements",
      refInFor: true,
      attrs: {
        "req": req
      }
    })
  }), 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1007:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unit) ? _c('div', {
    attrs: {
      "id": "unit-info"
    }
  }, [_c('transition', {
    attrs: {
      "name": "up-down",
      "mode": "out-in"
    }
  }, [(_vm.hasInfo) ? _c('div', [(_vm.unit && _vm.unit.description) ? _c('program-information') : _vm._e(), _vm._v(" "), (_vm.unit.cip_code) ? _c('career-opportunities', {
    attrs: {
      "cip": _vm.unit.cip_code
    }
  }) : _vm._e(), _vm._v(" "), (_vm.unit && _vm.unit.point_of_contact) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.unit && _vm.unit.point_of_contact) ? _c('contact-information') : _vm._e()], 1) : _c('div', [_vm._v("\n      No additional program information.\n    ")])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1008:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("\n    " + _vm._s(_vm.occupation.title) + "\n    "), (_vm.occupation.tags.green) ? [_c('img', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: ({
        content: "<span>Green</span> Occupation",
        offset: 5,
        classes: "green-tooltip"
      }),
      expression: "{ content: \"<span>Green</span> Occupation\", offset: 5, classes: \"green-tooltip\" }",
      modifiers: {
        "top-center": true
      }
    }],
    attrs: {
      "src": __webpack_require__(359),
      "height": "14"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.occupation.tags.bright_outlook) ? [_c('img', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: ({
        content: "<span>Bright</span> Outlook",
        offset: 5,
        classes: "bright-outlook-tooltip"
      }),
      expression: "{ content: \"<span>Bright</span> Outlook\", offset: 5, classes: \"bright-outlook-tooltip\" }",
      modifiers: {
        "top-center": true
      }
    }],
    attrs: {
      "src": __webpack_require__(358),
      "height": "14"
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dollars(_vm.occupation.salary.annual_median)))]), _vm._v(" "), _c('td', {
    staticClass: "salary-cell"
  }, [_c('div', {
    staticClass: "salary-occupation"
  }, [_c('div', {
    staticClass: "salary-labels"
  }, [_c('div', {
    staticClass: "salary-label salary-min",
    style: ({
      left: _vm.getSalaryOffset(_vm.salary10th)
    })
  }, [_vm._v("\n          " + _vm._s(_vm.dollars2(_vm.salary10th)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "salary-label salary-median",
    style: ({
      left: _vm.getSalaryOffset(_vm.salaryMedian)
    })
  }, [_vm._v("\n          " + _vm._s(_vm.dollars2(_vm.salaryMedian)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "salary-label salary-max",
    style: ({
      left: _vm.getSalaryOffset(_vm.salary90th)
    })
  }, [_vm._v("\n          " + _vm._s(_vm.dollars2(_vm.salary90th)) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "salary-markers"
  }, [_c('div', {
    staticClass: "salary-domain salary-marker-outer ds-border ds-main",
    style: (_vm.rangeStyles)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: ({
        content: "Annual 10th Percentile",
        offset: 5
      }),
      expression: "{ content: \"Annual 10th Percentile\", offset: 5 }",
      modifiers: {
        "top-center": true
      }
    }],
    staticClass: "salary-marker salary-marker-outer ds-border ds-main",
    style: ({
      left: _vm.getSalaryOffset(_vm.salary10th)
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: ({
        content: "Annual Median",
        offset: 5
      }),
      expression: "{ content: \"Annual Median\", offset: 5 }",
      modifiers: {
        "top-center": true
      }
    }],
    staticClass: "salary-marker ds-border ds-main",
    style: ({
      left: _vm.getSalaryOffset(_vm.salaryMedian)
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: ({
        content: "Annual 90th Percentile",
        offset: 5
      }),
      expression: "{ content: \"Annual 90th Percentile\", offset: 5 }",
      modifiers: {
        "top-center": true
      }
    }],
    staticClass: "salary-marker salary-marker-outer ds-border ds-main",
    style: ({
      left: _vm.getSalaryOffset(_vm.salary90th)
    })
  })])])])])
},staticRenderFns: []}

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(991),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 358:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return http; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_axios___default.a; });


var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: "https://blackbriar-uky-assets.s3.amazonaws.com/json"
});

/* unused harmony default export */ var _unused_webpack_default_export = (http);


/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_University__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_University___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_University__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Landing__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Landing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_KeywordSearch__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_KeywordSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_KeywordSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_CollegeSearch__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_CollegeSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_CollegeSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_InterestSearch__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_InterestSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_InterestSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Unit__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Unit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_Unit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_UnitPeriod__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_UnitPeriod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_UnitPeriod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_UnitPlans__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_UnitPlans___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_UnitPlans__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_UnitInfo__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_UnitInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_UnitInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_PageContent__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_PageContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_PageContent__);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var searches = [{
  path: 'name_search',
  name: 'nameSearch',
  component: __WEBPACK_IMPORTED_MODULE_4__views_KeywordSearch___default.a
}, {
  path: 'interest_search',
  name: 'interestSearch',
  component: __WEBPACK_IMPORTED_MODULE_6__views_InterestSearch___default.a
}, {
  path: 'units/:layout_id',
  component: __WEBPACK_IMPORTED_MODULE_7__views_Unit___default.a,
  children: [{
    path: '',
    name: 'unit-info',
    component: __WEBPACK_IMPORTED_MODULE_10__views_UnitInfo___default.a
  }, {
    path: 'periods/:period_id',
    component: __WEBPACK_IMPORTED_MODULE_8__views_UnitPeriod___default.a,
    children: [{
      path: 'plans',
      name: 'unit-plans',
      component: __WEBPACK_IMPORTED_MODULE_9__views_UnitPlans___default.a
    }]
  }]
  // {
  //   path: 'periods/:period_id/units/:layout_id',
  //   component: Unit,
  //   children: [
  //     {
  //       path: 'plans',
  //       name: 'unit-plans',
  //       component: UnitPlans
  //     }
  //   ]
  // }
}];

if (false) {
  searches.push({
    path: 'college_search',
    name: 'collegeSearch',
    component: CollegeSearch
  });
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // turn off history mode for now due to s3 deployment
  mode: 'history',
  routes: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_2__views_University___default.a,
    children: [{
      path: '',
      name: 'landing',
      component: __WEBPACK_IMPORTED_MODULE_3__views_Landing___default.a
    }, {
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_11__views_PageContent___default.a,
      children: searches
    }]
  }],

  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}));

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(94);



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loaded: false,
    university: {},
    layouts: [],
    periods: [],
    showArchived: false,
    selectedTermItem: null,
    unit: null,
    unitPeriod: null,
    id: "northern-kentucky-university",
    selectedProgramLevel: 'All',
    currentView: ''
    // majors: []
    // interestAreas: [],
  },

  mutations: {
    setUniversity: function setUniversity(state, u) {
      state.university = u;
    },
    setLayouts: function setLayouts(state, l) {
      state.layouts = l;
      state.loaded = true;
    },
    setPeriods: function setPeriods(state, p) {
      state.periods = p;
    },
    setShowArchived: function setShowArchived(state, s) {
      state.showArchived = s;
    },
    setSelectedTermItem: function setSelectedTermItem(state, i) {
      state.selectedTermItem = i;
    },
    setUnit: function setUnit(state, u) {
      state.unit = u;
    },
    setUnitPeriod: function setUnitPeriod(state, u) {
      state.unitPeriod = u;
    },
    setSelectedProgramLevel: function setSelectedProgramLevel(state, pl) {
      state.selectedProgramLevel = pl;
    },
    setCurrentView: function setCurrentView(state, v) {
      state.currentView = v;
    }
  },

  getters: {
    // format program and concentrations as a set of "majors"
    majors: function majors(state, getters) {
      return state.layouts.map(function (layout) {
        // make sure plan periods only include academic_periods that
        // are also in the list of university periods
        layout.planPeriods = layout.academic_periods.filter(function (p) {
          return getters.periodIds.includes(p.id) && p.plan_count;
        });

        layout.planPeriods.forEach(function (p) {
          p.name = state.periods.find(function (period) {
            return period.id === p.id;
          }).name;
        });

        layout.planPeriodIds = layout.planPeriods.map(function (p) {
          return p.id;
        });

        layout.currentPlanPeriod = layout.planPeriods.find(function (p) {
          return p.id === getters.currentPeriod.id;
        });

        layout.currentAcademicPeriod = layout.academic_periods.find(function (p) {
          return p.id === getters.currentPeriod.id;
        });

        return layout;
      }).filter(function (layout) {
        var typeCheck = ['program', 'concentration'].includes(layout.type);
        // const planCheck = layout.planPeriodIds.length

        return typeCheck;
      });
    },
    termIdentifier: function termIdentifier(state) {
      return state.university.term_identifier || 'Term';
    },


    // return current majors unless the showArchived flag is true
    currentMajors: function currentMajors(state, getters) {
      var majors = getters.majors;
      return (state.showArchived ? majors : majors.filter(function (m) {
        return !!m.currentAcademicPeriod;
      })) || [];
    },
    currentUniqueMajors: function currentUniqueMajors(state, getters) {
      // Return current unique programs (i.e. program code + concentration code is unique)
      var majors = getters.majors;
      var currentMajors = (state.showArchived ? majors : majors.filter(function (m) {
        return !!m.currentAcademicPeriod;
      })) || [];
      var flags = {};
      var uniqueMajors = [];

      for (var i = 0; i < currentMajors.length; i++) {
        var program = currentMajors[i].program.code;
        var programWithConcentration = !currentMajors[i].concentration ? program : program + currentMajors[i].concentration.code;

        if (!flags[programWithConcentration]) {
          uniqueMajors.push(currentMajors[i]);
          flags[programWithConcentration] = true;
        }
      }
      return uniqueMajors;
    },


    // return current collegess in nested format
    nestedCurrentColleges: function nestedCurrentColleges(state, getters) {
      var currentMajors = getters.currentMajors;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3__["e" /* nest */])().key(function (d) {
        return '' + (d.college || {}).name;
      }).sortKeys(__WEBPACK_IMPORTED_MODULE_1_d3__["d" /* ascending */]).entries(currentMajors);
    },


    // get latest period
    currentPeriod: function currentPeriod(state) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["maxBy"])(state.periods, function (p) {
        return p.code;
      }) || {};
    },


    // get a map of period ids
    periodIds: function periodIds(state) {
      return state.periods.map(function (p) {
        return p.id;
      });
    },


    // get current view
    currentView: function currentView(state) {
      return state.currentView;
    }
  }
});

/***/ }),

/***/ 364:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 365:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(952)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(983),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(989),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_requirement_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_requirement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_requirement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_polyfill__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__http__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_tooltip__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_js_modal__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_semantic_ui_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_semantic_ui_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_semantic_ui_vue__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.















// Import styles
__webpack_require__(365);
__webpack_require__(364);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// Make Axios global
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$axios = __WEBPACK_IMPORTED_MODULE_8__http__["a" /* axios */];

// AXIOS with base s3 url set
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_8__http__["b" /* http */];

// Global components
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('multiselect', __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('requirement', __WEBPACK_IMPORTED_MODULE_6__components_requirement_vue___default.a);

// Directives
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('focus', {
  inserted: function inserted(el) {
    el.focus();
  }
});

// Setup vue modal
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_js_modal___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_semantic_ui_vue___default.a);

// Setup Vuex store
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store(__WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */]);

// Setup VueAwesomeSwiper store
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper___default.a);

// setup v-tooltip
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_v_tooltip__["a" /* default */]);

// Setup Vue Analytics
if (true) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_analytics___default.a, {
    id: "",
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    set: [{ field: 'dimension1', value: "northern-kentucky-university" }, { field: 'dimension2', value: getPeriod() }]
  });
}

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: store,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

function getPeriod() {
  var date = new Date();
  var year = date.getFullYear();

  switch (date.getMonth()) {
    case 11:
    case 0:
      return 'Winter ' + year;
    case 1:
    case 2:
    case 3:
    case 4:
      return 'Spring ' + year;
    case 5:
    case 6:
      return 'Summer ' + year;
    case 7:
    case 8:
    case 9:
    case 10:
      return 'Fall ' + year;
  }
}

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(357);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

document.addEventListener('touchstart', function () {}, true);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  methods: {
    openFeedback: function openFeedback() {
      window.open(this.feedbackUrl);
    }
  },
  computed: {
    feedbackUrl: function feedbackUrl() {
      return this.$store.state.university.feedback_url;
    }
  }
});

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__occupation__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__occupation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__occupation__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var defaultCareerData = { occupations: [] };

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CareerOpportunities',

  data: function data() {
    return {
      dollars: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])('$.2s'),
      careerData: defaultCareerData
    };
  },
  created: function created() {
    this.fetchData();
  },


  watch: {
    '$route': 'fetchData'
  },

  props: {
    cip: {
      required: true,
      type: Object
    }
  },

  computed: {
    stateFullName: function stateFullName() {
      return __webpack_require__.i({"NODE_ENV":"production","BASE_URL":"https://blackbriar-uky-assets.s3.amazonaws.com/json","GOOGLE_ANALYTICS":"","UNIVERSITY_ID":"northern-kentucky-university","CAREERS_URL":"https://careers.damoursystems.com/","CONCENTRATION_NAME":"","PROGRAM_NAMING":"Program","COLLEGE_VIEW":false,"SHOW_COLLEGE":false})['STATE_FULL_NAME'];
    },
    stateSalaryData: function stateSalaryData() {
      return __webpack_require__.i({"NODE_ENV":"production","BASE_URL":"https://blackbriar-uky-assets.s3.amazonaws.com/json","GOOGLE_ANALYTICS":"","UNIVERSITY_ID":"northern-kentucky-university","CAREERS_URL":"https://careers.damoursystems.com/","CONCENTRATION_NAME":"","PROGRAM_NAMING":"Program","COLLEGE_VIEW":false,"SHOW_COLLEGE":false})['STATE_SALARY_DATA'];
    },
    salaryMin: function salaryMin() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3__["a" /* min */])(this.occupations, function (o) {
        return o.salary.annual_10th_percentile;
      });
    },
    salaryMax: function salaryMax() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3__["b" /* max */])(this.occupations, function (o) {
        return o.salary.annual_90th_percentile || o.salary.annual_90th_percentile_over;
      });
    },
    salaryMid: function salaryMid() {
      return (this.salaryMin + this.salaryMax) / 2;
    },
    salaryRange: function salaryRange() {
      return this.salaryMax - this.salaryMin;
    },
    occupations: function occupations() {
      return this.careerData.occupations.filter(function (o) {
        return o.salary;
      });
    },
    showGreenLegend: function showGreenLegend() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["some"])(this.careerData.occupations, function (o) {
        return o.tags.green;
      });
    },
    showBrightOutlookLegend: function showBrightOutlookLegend() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["some"])(this.careerData.occupations, function (o) {
        return o.tags.bright_outlook;
      });
    }
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.careerData = defaultCareerData;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_axios__["get"])('https://careers.damoursystems.com/cips/' + this.cip.code).then(function (response) {
        _this.careerData = response.data || defaultCareerData;
      });
    }
  },
  components: {
    Occupation: __WEBPACK_IMPORTED_MODULE_4__occupation___default.a
  }
});

/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__program_vue__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__program_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__program_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['college'],
  components: {
    Program: __WEBPACK_IMPORTED_MODULE_0__program_vue___default.a
  },

  computed: {
    showCollege: function showCollege() {
      return false;
    },
    currentView: function currentView() {
      return this.$store.getters.currentView;
    }
  }
});

/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// const defaultCareerData = { occupations: [] }

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContactInformation',

  data: function data() {
    return {};
  },


  computed: {
    unit: function unit() {
      return this.$store.state.unit;
    },
    pointOfContact: function pointOfContact() {
      return this.unit.point_of_contact;
    },
    phoneNumber: function phoneNumber() {
      return this.unit.phone_number;
    },
    phoneNumberM: function phoneNumberM() {
      return 'tel: ' + this.unit.phone_number.replace(/[^\w\s]/gi, '');
    },
    email: function email() {
      return this.unit.email;
    }
  },

  methods: {}
});

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_course_requisite__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_course_requisite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_course_requisite__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'course',

  // Properties
  // Req - The requirement object
  props: ['req'],

  components: {
    RequisitesString: __WEBPACK_IMPORTED_MODULE_0_vue_course_requisite__["RequisitesString"]
  },

  methods: {
    // used to roll credit count up to parent requirement sets
    computeMinimumCredits: function computeMinimumCredits() {
      return this.req.credits;
    }
  },

  computed: {
    name: function name() {
      var course = this.req.course;
      return course.name === course.full_number ? course.name : course.full_number + ' - ' + course.name;
    }
  }
});

/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'degree-requirement',

  // Properties
  // Req - The requirement object
  props: ['req'],

  data: function data() {
    return {
      showSubreqs: true // Flag to show or hide subrequrements
    };
  },
  mounted: function mounted() {
    // If the minimum credit hours differ from the minimum credit hours
    // based on subrequirements and satisfy value, then set the variable
    // flag to true
    // let sc = this.computeMinimumCredits()
    // if (sc != this.req.minimum_credits) {
    //   this.variable = true
    // }
  },


  computed: {
    // Number of subrequirements
    subrequirements: function subrequirements() {
      return this.req.subrequirements.length;
    }
  },

  methods: {
    // Set the collapse state of instance requirement and children
    setCollapseState: function setCollapseState(state) {
      this.showSubreqs = state;
      this.$refs.requirements.forEach(function (r) {
        return r.setCollapseState(state);
      });
    },

    // used to roll credit count up to parent requirement sets
    computeMinimumCredits: function computeMinimumCredits() {
      if (this.advanced) {
        return this.req.minimum_credits;
      } else if (this.$refs.requirements) {
        var credits = this.$refs.requirements.map(function (req) {
          return req.computeMinimumCredits();
        }).sort(function (a, b) {
          return a - b;
        });
        this.req.minimum_credits = this.req.maximum_credits = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["sum"])(credits.slice(0, this.req.required));
        return this.req.minimum_credits;
      } else {
        this.req.minimum_credits = 0;
        return this.req.minimum_credits;
      }
    }
  }
});

/***/ }),

/***/ 400:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__college_vue__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__college_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__college_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MajorList',

  data: function data() {
    // get a sortable key by removing any 2+ character sets of capital
    // letters or any symbols. If all characters are removed, fallback to
    // original string. Also append first character so that programs starting
    // with AS come before those with BS.
    var sortKey = function sortKey(string) {
      return string[0] + string.replace(/[A-Z]{2,}|[ \-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/g, ''); // eslint-disable-line no-useless-escape
    };

    var sortAscending = function sortAscending(a, b) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["d" /* ascending */])(sortKey(a), sortKey(b));
    };

    return {
      headerFixed: false,
      nest: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["e" /* nest */])().key(function (d) {
        return '' + (d.college || {}).name + (d.college || {}).code;
      }).sortKeys(__WEBPACK_IMPORTED_MODULE_0_d3__["d" /* ascending */]).key(function (d) {
        return '' + (d.program || {}).name + (d.program || {}).code;
      }).sortKeys(sortAscending)
    };
  },


  props: {
    majors: {
      requred: true
    },
    collegeSelectorShown: false
  },

  created: function created() {
    window.addEventListener('scroll', this.headerFixedCheck);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.headerFixedCheck);
  },


  computed: {
    showArchived: function showArchived() {
      return this.$store.state.showArchived;
    },
    selectedProgramLevel: function selectedProgramLevel() {
      return this.$store.state.selectedProgramLevel;
    },
    programLevelMajors: function programLevelMajors() {
      var _this = this;

      if (this.selectedProgramLevel === 'All') {
        return this.majors;
      } else {
        return this.majors.filter(function (m) {
          return m.program_level && m.program_level.name === _this.selectedProgramLevel;
        });
      }
    },
    nestedMajors: function nestedMajors() {
      return this.nest.entries(this.programLevelMajors);
    }
  },

  methods: {
    toggleArchived: function toggleArchived() {
      this.$store.commit('setShowArchived', !this.showArchived);
    },
    headerFixedCheck: function headerFixedCheck() {
      this.headerFixed = this.$refs.headerPlaceholder.getBoundingClientRect().y < 50;
    }
  },

  components: {
    College: __WEBPACK_IMPORTED_MODULE_1__college_vue___default.a
  }
});

/***/ }),

/***/ 401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(94);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    occupation: {
      type: Object,
      required: true
    },

    salaryMin: {
      type: Number,
      required: true
    },

    salaryRange: {
      type: Number,
      required: true
    }
  },

  data: function data() {
    return {
      dollars: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["c" /* format */])('$,'),
      dollars2: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["c" /* format */])('$.2s')
    };
  },


  computed: {
    salary10th: function salary10th() {
      return this.occupation.salary.annual_10th_percentile;
    },
    salaryMedian: function salaryMedian() {
      return this.occupation.salary.annual_median;
    },
    salary90th: function salary90th() {
      return this.occupation.salary.annual_90th_percentile || this.occupation.salary.annual_90th_percentile_over;
    },
    rangeStyles: function rangeStyles() {
      return {
        left: this.getSalaryOffset(this.salary10th),
        width: 100 * (this.salary90th - this.salary10th) / this.salaryRange + '%'
      };
    }
  },

  methods: {
    getSalaryOffset: function getSalaryOffset(salary) {
      return 100 * (salary - this.salaryMin) / this.salaryRange + '%';
    }
  }
});

/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unit_vue__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__unit_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['program'],

  components: {
    Unit: __WEBPACK_IMPORTED_MODULE_1__unit_vue___default.a
  },

  computed: {
    inactiveUnit: function inactiveUnit() {
      return {
        inactive: true,
        type: 'program',
        program: this.program.values[0].program
      };
    },
    unit: function unit() {
      return this.program.values.find(function (v) {
        return v.type === 'program';
      }) || this.inactiveUnit;
    },
    concentrations: function concentrations() {
      return this.program.values.filter(function (v) {
        return v.type === 'concentration';
      }).sort(function (a, b) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["d" /* ascending */])((a[a.type] || {}).name, (b[b.type] || {}).name);
      });
    }
  }
});

/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


// const defaultCareerData = { occupations: [] }

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProgramInformation',

  data: function data() {
    return {};
  },


  computed: {
    unit: function unit() {
      return this.$store.state.unit;
    },
    informationType: function informationType() {
      return this.unit.type;
    },
    programInfo: function programInfo() {
      return this.unit.description;
    },
    onlineAvailability: function onlineAvailability() {
      return this.unit.online_availability;
    },
    planName: function planName() {
      if (typeof this.unit.concentration === 'undefined') {
        return this.unit.program.name;
      } else {
        return this.unit.program.name + ': ' + this.unit.concentration.name;
      }
    },
    planType: function planType() {
      return this.unit.concentration ? 'Concentration' : 'Program';
    }
  },

  methods: {}
});

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__degree_requirement_vue__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__degree_requirement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__degree_requirement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__course_requirement_vue__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__course_requirement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__course_requirement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wild_card_requirement_vue__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wild_card_requirement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__wild_card_requirement_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'requirement',

  props: {
    req: true
  },

  components: {
    DegreeRequirement: __WEBPACK_IMPORTED_MODULE_0__degree_requirement_vue___default.a,
    Course: __WEBPACK_IMPORTED_MODULE_1__course_requirement_vue___default.a,
    Wildcard: __WEBPACK_IMPORTED_MODULE_2__wild_card_requirement_vue___default.a
  },

  methods: {
    mainRef: function mainRef() {
      return this.$refs.coreRequirement || this.$refs.degreeRequirement || this.$refs.courseRequirement || this.$refs.wildCardRequirement;
    },
    nestedRef: function nestedRef() {
      return this.$refs.degreeRequirement || this.$refs.coreRequirement;
    },
    setCollapseState: function setCollapseState(state) {
      var ref = this.nestedRef();
      if (ref) ref.setCollapseState(state);
    },
    computeMinimumCredits: function computeMinimumCredits() {
      var ref = this.mainRef();
      return ref ? ref.computeMinimumCredits() || 0 : 0;
    }
  }
});

/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__unit_archived_vue__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__unit_archived_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__unit_archived_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unit_current_vue__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unit_current_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__unit_current_vue__);
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['unit'],

  computed: {
    showArchived: function showArchived() {
      return this.$store.state.showArchived;
    }
  },

  components: {
    UnitArchived: __WEBPACK_IMPORTED_MODULE_0__unit_archived_vue___default.a,
    UnitCurrent: __WEBPACK_IMPORTED_MODULE_1__unit_current_vue___default.a
  }
});

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['unit'],

  data: function data() {
    return {
      period: null
    };
  },


  watch: {
    period: function period() {
      this.goToPlans();
    }
  },

  computed: {
    label: function label() {
      return '' + this.name; // (${this.code})`
    },
    type: function type() {
      var type = this.unit.type;
      if (type === 'concentration') {
        return "";
      }
      return "Program";
    },
    name: function name() {
      return (this.unit[this.unit.type] || {}).name;
    },
    active: function active() {
      return !this.unit.inactive;
    },
    periodId: function periodId() {
      return this.$store.getters.currentPeriod.id;
    },
    planString: function planString() {
      return this.plan_count > 1 ? 'Plans' : 'Plan';
    },
    planCount: function planCount() {
      return this.planPeriod.plan_count;
    },
    planPeriod: function planPeriod() {
      return this.unit.currentPlanPeriod;
    },
    classes: function classes() {
      return {
        'unit-item': true,
        'major-listing': true,
        'active': this.active
      };
    },
    unitParams: function unitParams() {
      return {
        period_id: this.periodId,
        layout_id: this.unit.university_layout_id
      };
    }
  },

  methods: {
    goToPlans: function goToPlans() {
      if (this.active) {
        this.$router.push({
          name: 'unit-plans',
          params: {
            period_id: this.period.id,
            layout_id: this.unit.university_layout_id
          }
        });
      }
    }
  }
});

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['unit'],

  computed: {
    level: function level() {
      if (this.unit.sub_program_level) {
        return this.unit.sub_program_level.code;
      } else if (this.unit.program_level) {
        return this.unit.program_level.code;
      } else {
        return '';
      }
    },
    onlineAvailability: function onlineAvailability() {
      if (this.unit.online_availability === undefined || this.unit.online_availability == 0) {
        return null;
      } else {
        return this.unit.online_availability;
      }
    },
    label: function label() {
      return '' + this.name; // (${this.code})`
    },
    type: function type() {
      var type = this.unit.type;
      if (type === 'concentration') {
        return "";
      }
      return "Program";
    },
    name: function name() {
      return (this.unit[this.unit.type] || {}).name;
    },
    code: function code() {
      return (this.unit[this.unit.type] || {}).code;
    },
    showArchived: function showArchived() {
      return this.$store.state.showArchived;
    },
    active: function active() {
      return !this.unit.inactive;
    },
    periodId: function periodId() {
      return this.$store.getters.currentPeriod.id;
    },
    classes: function classes() {
      return {
        'unit-item': true,
        'major-listing': true,
        'active': this.active
      };
    },
    nameStyle: function nameStyle() {
      if (this.active && this.planPeriod) return { cursor: 'pointer' };
    },
    planString: function planString() {
      return this.plan_count > 1 ? 'Plans' : 'Plan';
    },
    planCount: function planCount() {
      return this.planPeriod.plan_count;
    },
    planPeriod: function planPeriod() {
      return this.unit.currentPlanPeriod;
    },
    unitParams: function unitParams() {
      return {
        period_id: this.periodId,
        layout_id: this.unit.university_layout_id
      };
    }
  },
  methods: {
    goToPlans: function goToPlans() {
      if (this.active && this.planPeriod) {
        this.$router.push({
          name: 'unit-plans',
          params: this.unitParams
        });
      }
    }
  }
});

/***/ }),

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'wildcard',

  // Properties
  // Req - The requirement object
  props: ['req'],

  methods: {
    // used to roll credit count up to parent requirement sets
    computeMinimumCredits: function computeMinimumCredits() {
      return this.req.minimum_credits;
    }
  }
});

/***/ }),

/***/ 409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_major_list__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_major_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_major_list__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CollegeSearch',

  data: function data() {
    return {
      showColleges: false,
      colleges: [],
      selectedCollegeInd: null,
      majors: [],
      // collegeSelectorHidden: false,
      previousMajorListY: 0
    };
  },


  computed: {
    selectedCollege: function selectedCollege() {
      return this.colleges[this.selectedCollegeInd];
    },
    filteredColleges: function filteredColleges() {
      return this.colleges[this.selectedCollegeInd].values;
    }
  },

  created: function created() {
    window.addEventListener('scroll', this.setCollegeSelectorHidden);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.setCollegeSelectorHidden);
  },
  mounted: function mounted() {
    this.$store.commit('setCurrentView', 'collegeView');
    this.getColleges();
    // show the first college by default
    this.selectedCollegeInd = this.colleges.length !== 0 ? 0 : null;
  },


  methods: {
    getColleges: function getColleges() {
      this.colleges = this.$store.getters.nestedCurrentColleges;
    },
    selectCollege: function selectCollege(i) {
      this.selectedCollegeInd = i;
      this.showColleges = false;
    },
    setCollegeSelectorHidden: function setCollegeSelectorHidden() {
      var y = this.$refs.collegePlaceholder.getBoundingClientRect().y;
      var previousMajorListY = this.previousMajorListY;

      if (previousMajorListY > y + 2 || previousMajorListY < y - 2) {
        // this.collegeSelectorHidden = true
        this.showColleges = false;
      }

      // if (previousMajorListY < y - 2) {
      //   this.collegeSelectorHidden = false
      // }
      this.previousMajorListY = this.$refs.collegePlaceholder.getBoundingClientRect().y;
    }
  },

  components: {
    'major-list': __WEBPACK_IMPORTED_MODULE_0__components_major_list___default.a
  }
});

/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_major_list__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_major_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_major_list__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InterestSearch',

  data: function data() {
    var _this = this;

    return {
      notNextTick: true,
      autoPlayTimeout: null,
      allInterestAreas: [],
      swiperOptions: {
        slidesPerView: 5,
        mousewheelControl: true,
        // freeMode: true,
        spaceBetween: 20,
        direction: 'horizontal',
        centeredSlides: true,
        initialSlide: 0,
        threshold: 25,
        onSlideChangeStart: function onSlideChangeStart(swiper) {
          _this.goToArea(swiper.realIndex);
        }
      }
    };
  },
  created: function created() {
    var _this2 = this;

    this.setSlideCount();

    window.addEventListener('resize', function () {
      _this2.setSlideCount();
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$store.commit('setCurrentView', 'interestSearchView');
    this.$http('interest_areas.json').then(function (response) {
      _this3.allInterestAreas = response.data;
      if (!_this3.currentQuery) _this3.goToArea(0);
      _this3.swiperOptions.initialSlide = _this3.currentIndex;
    }).catch(function (error) {
      return console.log(error);
    });

    window.addEventListener('keyup', this.slide);
    this.resetAutoPlayTimeout();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keyup', this.slide);
    clearTimeout(this.autoPlayTimeout);
  },


  watch: {
    currentArea: function currentArea() {
      this.centerCarousel();
    }
  },

  computed: {
    // only include interest areas that have majors
    interestAreas: function interestAreas() {
      var _this4 = this;

      return this.allInterestAreas.filter(function (area) {
        return !!_this4.majors.find(function (major) {
          return major.master_cip_code_id === area.cip_code_id;
        });
      });
    },


    // get feedback url
    feedbackUrl: function feedbackUrl() {
      return this.$store.state.university.feedback_url;
    },


    // fetch majors from store
    majors: function majors() {
      if (false) {
        return this.$store.getters.currentMajors;
      }
      return this.$store.getters.currentUniqueMajors;
    },


    // majors for current interest area
    currentMajors: function currentMajors() {
      var _this5 = this;

      if (!this.currentArea) return [];
      return this.majors.filter(function (major) {
        return major.master_cip_code_id === _this5.currentArea.cip_code_id;
      });
    },


    // querystring current interest param
    currentQuery: function currentQuery() {
      return this.$route.query.interest;
    },


    // index of current interest area
    currentIndex: function currentIndex() {
      return this.interestAreas.indexOf(this.currentArea);
    },


    // current interest area
    currentArea: function currentArea() {
      var _this6 = this;

      return this.interestAreas.find(function (a) {
        return a.cip_code_id == _this6.currentQuery;
      });
    },


    // get selected from the query, on set $route to the interest area
    selected: {
      get: function get() {
        return ['true', true].includes(this.$route.query.selected);
      },
      set: function set(selected) {
        this.goToArea(this.currentIndex, selected);
      }
    },

    programNaming: function programNaming() {
      return "Program";
    }
  },

  methods: {
    // $route to interest area, optional selected query param may be set
    goToArea: function goToArea(index) {
      var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
      var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'replace';

      this.swiperOptions.initialSlide = index;
      var query = { interest: this.interestAreas[index].cip_code_id };
      if (selected) query.selected = true;
      this.$router[method]({
        name: 'interestSearch',
        query: query
      });
      this.resetAutoPlayTimeout();
    },
    openFeedback: function openFeedback() {
      window.open(this.feedbackUrl);
    },
    resetAutoPlayTimeout: function resetAutoPlayTimeout() {
      var _this7 = this;

      clearTimeout(this.autoPlayTimeout);
      this.autoPlayTimeout = setTimeout(function () {
        if (!_this7.selected) _this7.nextArea();
      }, 10000);
    },
    swiperClick: function swiperClick(area, i) {
      if (area === this.currentArea) this.selected = !this.selected;else this.goToArea(i);
    },


    // $route to next interest area
    nextArea: function nextArea() {
      var count = this.interestAreas.length - 1;
      var index = this.currentIndex;
      var next = index < count ? index + 1 : 0;
      this.goToArea(next);
    },


    // $route to next interest area
    previousArea: function previousArea() {
      var count = this.interestAreas.length - 1;
      var index = this.currentIndex;
      var prev = index > 0 ? index - 1 : count;
      this.goToArea(prev);
    },


    // interest area slide events for left right arrow keys
    slide: function slide(e) {
      if (e.keyCode === 37) {
        this.previousArea();
      } else if (e.keyCode === 39) {
        this.nextArea();
      }
    },
    setSlideCount: function setSlideCount() {
      this.swiperOptions.slidesPerView = Math.max(1.6, Math.round(document.body.clientWidth / 330));
    },
    centerCarousel: function centerCarousel() {
      if (this && this.$refs.swiper) {
        this.$refs.swiper.swiper.slideTo(this.currentIndex);
      }
    }
  },

  components: {
    MajorList: __WEBPACK_IMPORTED_MODULE_0__components_major_list___default.a
  }
});

/***/ }),

/***/ 411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_major_list__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_major_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_major_list__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'KeywordSearch',

  data: function data() {
    return {
      // searchKey: ''
      // majors: []
    };
  },
  mounted: function mounted() {
    this.$store.commit('setCurrentView', 'keywordSearchView');
  },


  computed: {
    searchKey: {
      get: function get() {
        return this.$route.query.keyword;
      },
      set: function set(keyword) {
        this.$router.replace({
          name: 'nameSearch',
          query: { keyword: keyword }
        });
      }
    },

    // Filters majors based on their name and the search key
    filteredMajors: function filteredMajors() {
      var searchRegex = new RegExp(this.searchKey, 'i');
      return this.majors.filter(function (major) {
        return searchRegex.test((major.program || {}).name) || searchRegex.test((major.program || {}).code) || searchRegex.test((major.concentration || {}).name) || searchRegex.test((major.concentration || {}).code);
      });
    },
    majors: function majors() {
      if (false) {
        return this.$store.getters.currentMajors;
      }
      return this.$store.getters.currentUniqueMajors;
    },
    showCollege: function showCollege() {
      return false;
    },
    programNaming: function programNaming() {
      return "Program";
    }
  },

  components: {
    'major-list': __WEBPACK_IMPORTED_MODULE_0__components_major_list___default.a
  }
});

/***/ }),

/***/ 412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Landing',

  data: function data() {
    return {
      searching: false,
      searchKey: ''
    };
  },


  computed: {
    showCollegeView: function showCollegeView() {
      return false;
    },
    programNaming: function programNaming() {
      return "Program";
    }
  },

  methods: {
    search: function search() {
      this.$router.push({
        name: 'nameSearch',
        query: { keyword: this.searchKey }
      });
    }
  }
});

/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['showCollegeLevel'],

  name: 'Unit',

  data: function data() {
    return {
      isFromMajorList: false
    };
  },


  computed: {
    name: function name() {
      return this.unit[this.unit.type].name;
    },
    level: function level() {
      if (this.unit.sub_program_level) {
        return this.unit.sub_program_level.name;
      } else if (this.unit.program_level) {
        return this.unit.program_level.name;
      } else {
        return '';
      }
    },
    programName: function programName() {
      return this.unit.program.name;
    },
    concentrationName: function concentrationName() {
      if (this.unit.concentration) {
        return ' / ' + this.unit.concentration.name;
      }
    },
    college: function college() {
      return this.unit.college.name;
    },


    unit: {
      get: function get() {
        return this.$store.state.unit;
      },
      set: function set(unit) {
        this.$store.commit('setUnit', unit);
      }
    },

    unitPeriod: function unitPeriod() {
      return this.$store.state.unitPeriod;
    },
    credits: function credits() {
      return this.unitPeriod.period_degree_joins[0].total_credit_hours;
    },
    unitPath: function unitPath() {
      return 'universities/' + "northern-kentucky-university" + '/university_layouts/' + this.$route.params.layout_id + '.json';
    },
    showCollege: function showCollege() {
      return false;
    },
    programNaming: function programNaming() {
      return "Program";
    },
    currentView: function currentView() {
      return this.$store.getters.currentView;
    }
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (from.name === 'nameSearch' || from.name === 'interestSearch') {
        vm.isFromMajorList = true;
      }
    });
  },
  created: function created() {
    this.fetchData();
  },


  watch: {
    '$route': 'fetchData'
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.unit = null;
      this.$http.get(this.unitPath).then(function (response) {
        _this.unit = response.data;
      }).catch(function (error) {
        console.log(error);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(error);
      });
    },
    goBack: function goBack() {
      if (this.isFromMajorList) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: 'nameSearch' });
      }
    }
  }
});

/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_career_opportunities_vue__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_career_opportunities_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_career_opportunities_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_program_information_vue__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_program_information_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_program_information_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contact_information_vue__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contact_information_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_contact_information_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UnitInfo',

  data: function data() {
    return {};
  },


  computed: {
    unit: function unit() {
      return this.$store.state.unit;
    },
    name: function name() {
      return this.unit[this.unit.type].name;
    },
    college: function college() {
      return this.unit.college.name;
    },
    hasInfo: function hasInfo() {
      return this.unit.cip_code || this.unit.description || this.unit.point_of_contact;
    }
  },

  components: {
    CareerOpportunities: __WEBPACK_IMPORTED_MODULE_0__components_career_opportunities_vue___default.a,
    ProgramInformation: __WEBPACK_IMPORTED_MODULE_1__components_program_information_vue___default.a,
    ContactInformation: __WEBPACK_IMPORTED_MODULE_2__components_contact_information_vue___default.a
  }
});

/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UnitPeriod',

  computed: {
    unitPeriod: {
      get: function get() {
        return this.$store.state.unitPeriod;
      },
      set: function set(unitPeriod) {
        this.$store.commit('setUnitPeriod', unitPeriod);
      }
    },

    unitPeriodPath: function unitPeriodPath() {
      return 'universities/' + "northern-kentucky-university" + '/academic_periods/' + this.$route.params.period_id + '/university_layouts/' + this.$route.params.layout_id + '.json';
    }
  },

  created: function created() {
    this.fetchData();
  },


  watch: {
    '$route': 'fetchData'
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.unitPeriod = null;
      this.$http.get(this.unitPeriodPath).then(function (response) {
        _this.unitPeriod = response.data;
      });
    }
  }
});

/***/ }),

/***/ 417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unm_idi_vue_degree_plan__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unm_idi_vue_degree_plan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__unm_idi_vue_degree_plan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(213);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import http from '../http'


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UnitPlans',

  data: function data() {
    var planTypes = [['Plan', 'fa-list'], ['Grid', 'fa-th'], ['Graph', 'fa-share-alt']];
    return {
      // unit: null,
      activePlanIndex: 0,
      selectedPlanType: planTypes[0],
      planTypes: planTypes,
      formatTerms: __WEBPACK_IMPORTED_MODULE_1__unm_idi_vue_degree_plan__["formatTerms"]
    };
  },
  mounted: function mounted() {
    this.getPlans();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['termIdentifier']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['unitPeriod']), {

    selectedTermItem: {
      get: function get() {
        return this.$store.state.selectedTermItem;
      },
      set: function set(item) {
        this.$store.commit('setSelectedTermItem', item);
      }
    },

    name: function name() {
      return this.unitPeriod[this.unitPeriod.type].name;
    },
    college: function college() {
      return this.unitPeriod.college.name;
    },
    credits: function credits() {
      return this.unitPeriod.period_degree_joins[0].total_credit_hours;
    },
    plans: function plans() {
      return this.unitPeriod.period_degree_joins[0].plan_period_joins;
    },
    activePlan: function activePlan() {
      return this.plans[this.activePlanIndex];
    }
  }),

  // beforeRouteEnter(to, from, next) {
  //   // // Pulls all plan information
  //   http.get('universities/' + process.env.UNIVERSITY_ID + '/academic_periods/' + to.params.period_id + '/university_layouts/' + to.params.layout_id + '.json').then(response => {
  //     next(vm => {
  //       vm.unitPeriod = response.data
  //     })
  //   })
  // },

  methods: {
    sortTerms: function sortTerms(terms) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["sortBy"])(terms, 'position');
    },
    getPlans: function getPlans() {
      // Pulls all plan information
      // this.$http.get('universities/' + this.$store.state.id + '/academic_periods/' + this.$route.params.period_id + '/university_layouts/' + this.$route.params.layout_id + '.json').then(response => {
      //   this.name = response.data[response.data.type].name
      //   this.college = response.data.college.name
      //   this.credits = response.data.period_degree_joins[0].total_credit_hours
      //   this.plans = response.data.period_degree_joins[0].plan_period_joins
      //   this.activePlan = this.plans[0].id
      // })
    }
  },

  components: {
    Plan: __WEBPACK_IMPORTED_MODULE_1__unm_idi_vue_degree_plan__["Plan"],
    Graph: __WEBPACK_IMPORTED_MODULE_1__unm_idi_vue_degree_plan__["Graph"],
    Grid: __WEBPACK_IMPORTED_MODULE_1__unm_idi_vue_degree_plan__["Grid"]
  }
});

/***/ }),

/***/ 418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'University',

  data: function data() {
    return {
      // showNav: false,
      searchFocused: false,
      showSearchDropdown: false,
      showProgramLevelDropdown: false,
      // selectedProgramLevel: 'Bachelor\'s',
      searchKey: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.setUniversity();
    this.setLayouts();
    this.setPeriods();
    document.body.addEventListener('click', function () {
      // this.showNav = false
      _this.showProgramLevelDropdown = false;
    });
  },


  watch: {
    showNav: function showNav(bool) {
      document.body[bool ? 'addEventListener' : 'removeEventListener']('click', this.toggleNav);
    },
    $route: function $route() {
      this.showSearchDropdown = this.showProgramLevelDropdown = false;
    }
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // console.log('University Enter')
    next();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // console.log('University Update')
    next();
  },


  computed: {
    // Returns the url to the university's stylesheet
    stylesheet: function stylesheet() {
      return this.$store.state.university.styles_url;
    },


    // Returns a url to the university's logo
    logo: function logo() {
      return this.$store.state.university.logo_url;
    },


    // // Returns a url to the university's favicon
    // favicon() {
    //   return this.$store.state.university.favicon_url
    // },

    // Checks if currently on the landing route
    homeRoute: function homeRoute() {
      return this.$route.name == 'landing';
    },


    // University ID
    id: function id() {
      return this.$store.state.id;
    },
    showProgramLevelMenu: function showProgramLevelMenu() {
      return ['nameSearch', 'interestSearch'].includes(this.$route.name) && this.programLevels.length > 1;
    },
    programLevels: function programLevels() {
      return ['All'].concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["uniq"])(this.$store.getters.currentMajors.filter(function (m) {
        return m.program_level;
      }).map(function (m) {
        return m.program_level.name;
      })));
    },


    selectedProgramLevel: {
      get: function get() {
        return this.$store.state.selectedProgramLevel;
      },
      set: function set(pl) {
        this.$store.commit('setSelectedProgramLevel', pl);
      }
    }
  },

  methods: {
    search: function search() {
      this.$router.push({
        name: 'nameSearch',
        query: { keyword: this.searchKey }
      });
      this.searchKey = '';
    },


    // toggleNav() {
    //   this.showNav = !this.showNav
    // },

    // Saves the universities info to the store
    setUniversity: function setUniversity() {
      var _this2 = this;

      this.$http('universities/' + this.id + '.json').then(function (response) {
        _this2.$store.commit('setUniversity', response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },


    // Pulls the university Layouts file
    setLayouts: function setLayouts() {
      var _this3 = this;

      this.$http('universities/' + this.id + '/university_layouts.json').then(function (response) {
        _this3.$store.commit('setLayouts', response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },


    // Pulls the university period joins with degree roadmaps enabled
    setPeriods: function setPeriods() {
      var _this4 = this;

      this.$http('universities/' + this.id + '/university_period_joins.json').then(function (response) {
        // only write periods that are published for degree_roadmaps
        var filtered = response.data.filter(function (join) {
          return join.has_plan_content;
        }).map(function (join) {
          return join.academic_period;
        });
        _this4.$store.commit('setPeriods', filtered);
      }).catch(function (error) {
        console.log(error);
      });
    }

    // closeNav() {
    //   this.showNav = false
    // }

  }
});

/***/ }),

/***/ 952:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(988),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(998),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(995),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(984),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(1006),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(1008),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(986),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(990),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(987),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(1000),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(1001),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 969:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(1003),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(993),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(999),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(997),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(996),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(994),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(992),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(1007),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(1002),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(1005),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(985),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(982),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(1004),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 982:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 983:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 984:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "course-requirement req"
  }, [_c('div', {
    staticClass: "reqinfo"
  }, [_c('div', {
    staticClass: "course-name req-name"
  }, [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]), _vm._v(" "), (_vm.req.advanced) ? _c('div', {
    staticClass: "req-item"
  }, [_vm._v("Credit Hours: " + _vm._s(_vm.req.credits))]) : _c('div', {
    staticClass: "req-item"
  }, [_vm._v("Credit Hours: " + _vm._s(_vm.req.course.minimum_credits))]), _vm._v(" "), _c('div', {
    staticClass: "req-item"
  }, [_vm._v("Minimum Grade: " + _vm._s(_vm.req.minimum_grade))]), _vm._v(" "), (_vm.req.advanced) ? _c('div', {
    staticClass: "req-item"
  }, [_vm._v("Attempts: " + _vm._s(_vm.req.attempts))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.req.course.description) ? _c('div', {
    staticClass: "course-description"
  }, [_vm._v("\n      Course Description: " + _vm._s(_vm.req.course.description) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.req.course.prereq) ? _c('div', {
    staticClass: "course-prereq"
  }, [_vm._v("\n      Prerequisites:\n      "), _c('requisites-string', {
    attrs: {
      "operand": _vm.req.course.prereq,
      "requisiteType": "prereq"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.req.course.coreq) ? _c('div', {
    staticClass: "course-coreq"
  }, [_vm._v("\n      Corequisites:\n      "), _c('requisites-string', {
    attrs: {
      "operand": _vm.req.course.coreq,
      "requisiteType": "coreq"
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 985:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.loaded) ? _c('div', {
    attrs: {
      "id": "university"
    }
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "property": "stylesheet",
      "href": _vm.stylesheet
    }
  }), _vm._v(" "), _c('header', {
    staticClass: "ds-main",
    class: {
      'ds-background': !_vm.homeRoute, 'home': _vm.homeRoute
    }
  }, [_c('div', {
    attrs: {
      "id": "header-wraper"
    }
  }, [_c('router-link', {
    staticClass: "header-img",
    attrs: {
      "to": {
        name: 'landing'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "menu-items"
    }
  }, [_c('div', {
    staticClass: "menu-trigger menu-item",
    class: {
      focused: _vm.searchFocused
    },
    attrs: {
      "id": "search-menu"
    }
  }, [_c('i', {
    staticClass: "fas fa-search"
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.search($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search or jump to..."
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "focus": function($event) {
        _vm.searchFocused = true
      },
      "blur": function($event) {
        _vm.searchFocused = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "menu-dropdown"
    }
  }, [(_vm.searchFocused) ? _c('ul', {
    staticClass: "menu-dropdown ds-main ds-background"
  }, [(_vm.$route.name !== 'nameSearch') ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'nameSearch'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNav($event)
      }
    }
  }, [_vm._v("All Programs")])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'interestSearch') ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'interestSearch'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNav($event)
      }
    }
  }, [_vm._v("Interest Areas")])], 1) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), (_vm.showProgramLevelMenu) ? _c('div', {
    staticClass: "menu-trigger menu-item",
    class: {
      selected: _vm.showProgramLevelDropdown
    },
    attrs: {
      "id": "program-level-menu"
    }
  }, [_c('div', {
    staticClass: "menu-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.showProgramLevelDropdown = !_vm.showProgramLevelDropdown
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.selectedProgramLevel) + " "), _c('i', {
    staticClass: "fas fa-chevron-down"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "menu-dropdown"
    }
  }, [(_vm.showProgramLevelDropdown) ? _c('ul', {
    staticClass: "menu-dropdown ds-main ds-background"
  }, _vm._l((_vm.programLevels), function(level) {
    return _c('li', {
      key: level
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.selectedProgramLevel = level
        }
      }
    }, [_vm._v(_vm._s(level))])])
  }), 0) : _vm._e()])], 1) : _vm._e()])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "router",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 986:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "program"
  }, [_c('i', {
    staticClass: "program-bookmark fa fa-bookmark"
  }), _vm._v(" "), _c('div', {
    class: {
      "program-line": _vm.concentrations.length > 0
    }
  }), _vm._v(" "), _c('unit', {
    attrs: {
      "unit": _vm.unit
    }
  }), _vm._v(" "), _vm._l((_vm.concentrations), function(concentration) {
    return _c('unit', {
      key: concentration.id,
      staticClass: "concentration",
      attrs: {
        "unit": concentration
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 987:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showArchived) ? _c('unit-archived', {
    attrs: {
      "unit": _vm.unit
    }
  }) : _c('unit-current', {
    attrs: {
      "unit": _vm.unit
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 988:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "career-opportunities"
    }
  }, [_c('h2', [_vm._v("Career Opportunities")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cip.definition))]), _vm._v(" "), _c('sui-accordion', {
    attrs: {
      "exclusive": "",
      "styled": "",
      "fluid": ""
    }
  }, [_c('sui-accordion-title', {
    attrs: {
      "active": ""
    }
  }, [_c('h3', [_vm._v("In the U.S"), _c('sui-icon', {
    attrs: {
      "name": "dropdown"
    }
  })], 1)]), _vm._v(" "), _c('sui-accordion-content', {
    attrs: {
      "active": ""
    }
  }, [(_vm.occupations.length) ? [_c('table', [_c('tr', [_c('th', [_vm._v("Occupation")]), _vm._v(" "), _c('th', [_vm._v("Median Salary")]), _vm._v(" "), _c('th', {
    staticClass: "salary-cell"
  }, [_vm._v("Salary Range")])]), _vm._v(" "), _c('tr', {
    staticClass: "salary-row"
  }, [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "salary-cell"
  }, [_c('div', {
    staticClass: "salary-scale"
  }, [_c('div', {
    staticClass: "salary-scale-min salary-scale-label"
  }, [_vm._v(_vm._s(_vm.dollars(_vm.salaryMin)))]), _vm._v(" "), _c('div', {
    staticClass: "salary-scale-mid salary-scale-label"
  }, [_vm._v(_vm._s(_vm.dollars(_vm.salaryMid)))]), _vm._v(" "), _c('div', {
    staticClass: "salary-scale-max salary-scale-label"
  }, [_vm._v(_vm._s(_vm.dollars(_vm.salaryMax)))]), _vm._v(" "), _c('div', {
    staticClass: "salary-scale-domain"
  })])])]), _vm._v(" "), _vm._l((_vm.occupations), function(occupation) {
    return (occupation.salary && occupation.tags && occupation.salary.annual_median) ? _c("occupation", {
      key: occupation.code,
      tag: "tr",
      attrs: {
        "occupation": occupation,
        "salary-min": _vm.salaryMin,
        "salary-range": _vm.salaryRange
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("\n          Career data obtained from the Occupational Information Network (O*NET).\n          These occupations are identified based on the CIP code for " + _vm._s(_vm.cip.name) + "\n          (" + _vm._s(_vm.cip.code) + "). The salary range depicts the 10th percentile, median, and\n          90th percentile salary values for each occupation.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "job-legend"
  }, [(_vm.showGreenLegend) ? [_c('div', {
    staticClass: "job-legend-header"
  }, [_c('span', {
    staticClass: "job-legend-icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(359),
      "height": "24"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "job-legend-label"
  }, [_vm._v("Green Occupation")])]), _vm._v(" "), _c('p', [_vm._v("\n              Green occupations will likely change as a result of the green economy.\n              Green economy activities and technologies are increasing the demand for\n              occupations, shaping the work and worker requirements needed for\n              occupational performance, or generating new and emerging occupations.\n            ")])] : _vm._e(), _vm._v(" "), (_vm.showBrightOutlookLegend) ? [_c('div', {
    staticClass: "job-legend-header"
  }, [_c('span', {
    staticClass: "job-legend-icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(358),
      "height": "24"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "job-legend-label"
  }, [_vm._v("Bright Outlook")])]), _vm._v(" "), _c('p', [_vm._v("\n              Bright Outlook occupations are expected to grow rapidly in the next\n              several years, will have large numbers of job openings, or are new and\n              emerging occupations.\n            ")])] : _vm._e()], 2)] : _vm._e()], 2), _vm._v(" "), _c('sui-accordion-title', [_c('h3', [_vm._v("In the State of Kentucky"), _c('sui-icon', {
    attrs: {
      "name": "dropdown"
    }
  })], 1)]), _vm._v(" "), _c('sui-accordion-content', [_vm._v("\n      State salary information can be found at the following link: "), _c('a', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": "https://reports.ky.gov/t/CPE/views/KentuckyPostsecondaryEducationInteractiveDataDashboard/StudentRighttoKnow?%3AshowAppBanner=false&%3Adisplay_count=n&%3AshowVizHome=n&%3Aorigin=viz_share_link&%3AisGuestRedirectFromVizportal=y&%3Aembed=y",
      "target": "_blank"
    }
  }, [_vm._v("Please click here")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 989:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.req.type == 'CoreRequirement') ? _c('div', {
    staticClass: "coreinfo"
  }, [_c('requirement', {
    ref: "coreRequirement",
    attrs: {
      "req": _vm.req.core
    }
  })], 1) : _c('div', {
    staticClass: "requirement"
  }, [(_vm.req.type == 'DegreeRequirement') ? _c('degree-requirement', {
    ref: "degreeRequirement",
    attrs: {
      "req": _vm.req
    }
  }) : _vm._e(), _vm._v(" "), (_vm.req.type == 'CourseRequirement') ? _c('course', {
    ref: "courseRequirement",
    attrs: {
      "req": _vm.req
    }
  }) : _vm._e(), _vm._v(" "), (_vm.req.type == 'WildCardRequirement') ? _c('wildcard', {
    ref: "wildCardRequirement",
    attrs: {
      "req": _vm.req
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 990:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unit) ? _c('div', {
    staticClass: "program-info-wrap"
  }, [_c('h2', [_vm._v(" " + _vm._s(_vm.informationType) + " Information ")]), _vm._v(" "), _c('p', {
    staticClass: "program-info"
  }, [_c('code', {
    staticClass: "program-info",
    domProps: {
      "innerHTML": _vm._s(_vm.programInfo)
    }
  })]), _vm._v(" "), (_vm.onlineAvailability) ? _c('p', [_c('b', [_vm._v("Online Availability:")]), _vm._v(" " + _vm._s(_vm.onlineAvailability))]) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 991:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "majors-list"
  }, [_c('div', {
    staticClass: "majors-toggle-archived"
  }, [_c('button', {
    staticClass: "hollow",
    on: {
      "click": _vm.toggleArchived
    }
  }, [_vm._v("\n      " + _vm._s(_vm.showArchived ? "Hide Archived" : "Show Archived") + "\n    ")])]), _vm._v(" "), _c('div', {
    ref: "headerPlaceholder",
    staticClass: "listing-header-placeholder",
    class: {
      "header-fixed": _vm.headerFixed
    }
  }), _vm._v(" "), (!_vm.showArchived) ? _c('div', {
    ref: "header",
    staticClass: "listing-header",
    class: {
      "header-fixed": _vm.headerFixed, "college-selector-shown": _vm.collegeSelectorShown
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.nestedMajors), function(college) {
    return _c('college', {
      key: college.key,
      attrs: {
        "college": college
      }
    })
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unit-content"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "unit-name"
  }, [_c('span', [_vm._v("Level")])]), _vm._v(" "), _c('div', {
    staticClass: "unit-level"
  }, [_c('span', [_vm._v("Degree")])]), _vm._v(" "), _c('div', {
    staticClass: "unit-availabitlity"
  }, [_c('span', [_vm._v("Online")])]), _vm._v(" "), _c('div', {
    staticClass: "unit-plans"
  }, [_c('span', [_vm._v("Plan")])]), _vm._v(" "), _c('div', {
    staticClass: "unit-credits"
  }, [_c('span', [_vm._v("Credits")])]), _vm._v(" "), _c('div', {
    staticClass: "header-button"
  }, [_c('span', [_vm._v("Information")])]), _vm._v(" "), _c('div', {
    staticClass: "header-button"
  }, [_c('span', [_vm._v("Degree Plan")])])])])
}]}

/***/ }),

/***/ 992:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unit) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "unit"
    }
  }, [_c('div', {
    attrs: {
      "id": "unit-header"
    }
  }, [_c('div', {
    attrs: {
      "id": "unit-name"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.college && (_vm.currentView === 'collegeView' || _vm.showCollege)) ? _c('h4', [(_vm.level) ? [_vm._v(_vm._s(_vm.level) + " | ")] : _vm._e(), _vm._v(_vm._s(_vm.college) + "\n        ")], 2) : _vm._e(), _vm._v(" "), (!(_vm.currentView === 'collegeView' || _vm.showCollege)) ? _c('h4', [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header-credits"
  }, [(_vm.unitPeriod && _vm.credits && _vm.$route.name === 'unit-plans') ? _c('span', [_vm._v(_vm._s(_vm.credits) + " Credit Hours")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "breadcrumbs"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goBack($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.programNaming) + "s")]), _vm._v(" / "), _c('span', [_vm._v(_vm._s(_vm.programName))]), _vm._v(" "), (_vm.concentrationName) ? _c('span', [_vm._v(_vm._s(_vm.concentrationName))]) : _vm._e(), _vm._v(" "), (_vm.$route.name === "unit-plans") ? [_vm._v("/ "), _c('span', [_vm._v("Degree Plan")])] : _vm._e()], 2)]), _vm._v(" "), _c('router-view')], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-container"
  }, [_c('div', {
    staticClass: "background-image"
  })])
}]}

/***/ }),

/***/ 993:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "college-search"
    }
  }, [_c('div', {
    attrs: {
      "id": "college-list"
    }
  }, [_c('h4', {
    on: {
      "click": function($event) {
        _vm.showColleges = !_vm.showColleges
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.selectedCollegeInd == null ? 'Select College' : 'Change College') + "\n      "), _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    class: {
      show: _vm.showColleges
    },
    attrs: {
      "id": "list-wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "list"
    }
  }, _vm._l((_vm.colleges), function(college, i) {
    return _c('a', {
      staticClass: "ds-main ds-color-hover",
      class: {
        active: _vm.selectedCollegeInd == i
      },
      on: {
        "click": function($event) {
          return _vm.selectCollege(i)
        }
      }
    }, [_vm._v("\n            " + _vm._s(college.key) + "\n          ")])
  }), 0)])]), _vm._v(" "), (_vm.selectedCollegeInd != null) ? _c('div', {
    ref: "collegePlaceholder",
    attrs: {
      "id": "college-majors"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.selectedCollege.key))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.selectedCollege.values.length) + " Program" + _vm._s(_vm.selectedCollege.values.length > 1 ? 's' : ''))]), _vm._v(" "), _c('major-list', {
    attrs: {
      "majors": _vm.filteredColleges,
      "collegeSelectorShown": true
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 994:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 995:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unit) ? _c('div', {
    attrs: {
      "id": "career-opportunities"
    }
  }, [_c('h2', [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_c('b', [_c('code', {
    staticClass: "program-info",
    domProps: {
      "innerHTML": _vm._s(_vm.pointOfContact)
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.phoneNumber) ? _c('a', {
    staticClass: "contact",
    attrs: {
      "target": "_parent",
      "href": _vm.phoneNumberM
    }
  }, [_vm._v(" " + _vm._s(_vm.phoneNumber))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.email) ? _c('a', {
    staticClass: "contact",
    attrs: {
      "target": "_parent",
      "href": 'mailto:' + _vm.email
    }
  }, [_vm._v(_vm._s(_vm.email))]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 996:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "majors"
    },
    on: {
      "click": function($event) {
        _vm.searching = false
      }
    }
  }, [_c('div', {
    staticClass: "ds-main ds-background",
    attrs: {
      "id": "landing-hero"
    }
  }, [_c('div', {
    attrs: {
      "id": "landing"
    }
  }, [_c('h1', [_vm._v("Find Your Degree")]), _vm._v(" "), _c('h2', [_vm._v("Explore our many programs of study to find the one that best fits you.")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "search-links"
    }
  }, [_c('div', {
    staticClass: "search-link-column",
    class: {
      collegeview: _vm.showCollegeView
    }
  }, [_c('router-link', {
    staticClass: "ds-main ds-color-hover search-link",
    attrs: {
      "to": {
        name: 'nameSearch'
      }
    }
  }, [_vm._v("\n            All " + _vm._s(_vm.programNaming) + "s\n          ")])], 1), _vm._v(" "), (_vm.showCollegeView) ? _c('div', {
    staticClass: "search-link-column",
    class: {
      collegeview: _vm.showCollegeView
    }
  }, [_c('router-link', {
    staticClass: "ds-main ds-color-hover search-link",
    attrs: {
      "to": {
        name: 'collegeSearch'
      }
    }
  }, [_vm._v("\n            Select by College\n          ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "search-link-column keyword-search",
    class: {
      collegeview: _vm.showCollegeView
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.searching = true
      }
    }
  }, [(_vm.searching) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.search($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    ref: "searchBox",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  }), _vm._m(0)]) : _c('a', {
    staticClass: "ds-main ds-color-hover search-link"
  }, [_c('i', {
    staticClass: "fas fa-search"
  }), _vm._v("\n            Find by Keyword\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "search-link-column",
    class: {
      collegeview: _vm.showCollegeView
    }
  }, [_c('router-link', {
    staticClass: "ds-main ds-color-hover search-link",
    attrs: {
      "to": {
        name: 'interestSearch'
      }
    }
  }, [_vm._v("\n            Search by Interest\n          ")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fas fa-search"
  })])
}]}

/***/ }),

/***/ 997:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "search-by-keyword"
    }
  }, [_c('div', {
    attrs: {
      "id": "searchbar"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-search"
  })]), _vm._v(" "), (!_vm.showCollege && !_vm.searchKey) ? _c('div', {
    ref: "collegePlaceholder",
    attrs: {
      "id": "college-majors"
    }
  }, [_c('h1', [_vm._v("All " + _vm._s(_vm.programNaming) + _vm._s(_vm.majors.length > 1 ? 's' : ''))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.majors.length) + " " + _vm._s(_vm.programNaming) + _vm._s(_vm.majors.length > 1 ? 's' : ''))])]) : _vm._e(), _vm._v(" "), _c('major-list', {
    attrs: {
      "majors": _vm.filteredMajors
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 998:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "units-by-college"
  }, [(_vm.currentView !== "collegeView" && _vm.showCollege) ? _c('div', {
    staticClass: "unit-college"
  }, [_vm._v(_vm._s((_vm.college.values[0].values[0].college || {}).name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "unit-items"
  }, _vm._l((_vm.college.values), function(program) {
    return _c('program', {
      key: program.key,
      attrs: {
        "program": program
      }
    })
  }), 1)])
},staticRenderFns: []}

/***/ }),

/***/ 999:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "interest-search"
    }
  }, [(_vm.currentArea) ? _c('div', {
    staticClass: "ds-main ds-border",
    class: {
      'show-majors': _vm.selected
    },
    attrs: {
      "id": "carousel"
    }
  }, [_c('img', {
    staticClass: "slide-img",
    attrs: {
      "src": _vm.currentArea.large_image_url
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.selected) ? _c('div', {
    staticClass: "arrow",
    on: {
      "click": _vm.previousArea
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.selected) ? _c('div', {
    staticClass: "slide-info"
  }, [_c('h1', [_vm._v(_vm._s(_vm.currentArea.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.currentArea.definition))]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.selected = true
      }
    }
  }, [_vm._v("See " + _vm._s(_vm.programNaming))])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.selected) ? _c('div', {
    staticClass: "arrow",
    on: {
      "click": _vm.nextArea
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "carousel-swiper"
    }
  }, [_c('swiper', {
    ref: "swiper",
    attrs: {
      "options": _vm.swiperOptions,
      "not-next-tick": _vm.notNextTick
    }
  }, _vm._l((_vm.interestAreas), function(area, i) {
    return _c('swiper-slide', {
      key: i
    }, [_c('div', {
      staticClass: "swiper-content ds-main ds-border",
      class: {
        'current-area': area === _vm.currentArea
      },
      on: {
        "click": function($event) {
          return _vm.swiperClick(area, i)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "swiper-img",
      attrs: {
        "src": area.large_image_url
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "swiper-img",
      attrs: {
        "src": area.medium_image_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "swiper-title"
    }, [_vm._v("\n              " + _vm._s(area.name) + "\n            ")])])])
  }), 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "carousel-back"
    }
  }, [(_vm.selected) ? _c('div', {
    staticClass: "carousel-back ds-main ds-background",
    on: {
      "click": function($event) {
        _vm.selected = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.selected) ? _c('div', {
    attrs: {
      "id": "interest-majors"
    }
  }, [_c('major-list', {
    attrs: {
      "majors": _vm.currentMajors
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ })

},[391]);


// WEBPACK FOOTER //
// static/js/app.363c0dcc0ce3202c31e1.js